import styled from "@emotion/styled";

export const AuthLayoutWrapper = styled.div`
  box-sizing: border-box;
  background: transparent;
  color: #fff;
  position: relative;
`;
